import Image from "next/image";
import styles from "./tnpsc-mains-test-series.module.css"
//import group2amaintest from "../../assets/images/Tnpsc/group2amaintest.png";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Head from "next/head";
import Link from "next/link";
const Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper1 = () =>{
   
    return(
        <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group 2 Mains Test Batch | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Group 2 Mains Test Batch | Shankar IAS Academy" />
            <meta name="description" content="Shankar IAS Academy presents TNPSC Group 2 Mains Test Batch. Elevate your preparation with expert guidance and proven strategies. Join Now!" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group 2 Mains Test Batch | Shankar IAS Academy" />
            <meta property="og:description" content="Shankar IAS Academy presents TNPSC Group 2 Mains Test Batch. Elevate your preparation with expert guidance and proven strategies. Join Now!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>
    
        <Navbar title="tnpsc" />

        <div className="container">

            <div className="row">
            <div className="col pt-3 pt-md-4">
                <h1 className={`${styles.pagemaintitle}`}>TNPSC Group II/II-A Mains 2022 New Test Series</h1>
            </div>
            </div>

           {/* <div className="row">
            <div className="col pt-2 mb-3">
                <Image src={group2amaintest} alt="tnpsc-mains-paper-1 banner" title="TNPSC Group II/II-A Mains 2022 New Test Series" className="img-fluid w-100" />
            </div>
            </div> */}

            <div className="row pt-2">
            <div className="col-md-9 col-12">
                <h2 className={`${styles.sectiontitle} mb-0`}>TNPSC Group II/II-A Mains 2022 New Test Series Paper I</h2>
            </div>
            <div className="col">
            <Link href="/tnpsc-group-II-mains-test-series" ><button className={`${styles.normalbutton1} mt-2 mt-md-0`} type="submit">TNPSC Group II/II-A Mains Paper II</button></Link>
            </div>
            </div>

        </div>

{/* table */}
       
<div className="container d-none d-lg-block">
    <div className="row pt-3 prelimstable">
        <div className="col">
          <div className={`${styles.tablescroll}`}>
                 <table class="table">
                     <thead class="table" style={{backgroundColor:"#818C98"}}>
                        <tr>
                            <td className={`${styles.tableheading}`}>Center<br/></td>
                            <td className={`${styles.tableheading}`}>Batch<br/></td>
                            <td className={`${styles.tableheading}`}>Fee<br/></td>
                            <td className={`${styles.tableheading}`}>Schedule<br/></td>
                            <td className={`${styles.tableheading}`}>Payment<br/></td>
                        </tr>
                 </thead>
                 <tbody>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Chennai - Anna Nagar<br/></td>
                            <td className={`${styles.tablepara}`}>Weekend<br/><p className={`${styles.tablepara}`}>(Offline/Online)</p></td>
                            <td className={`${styles.tablepara}`}>₹5500 (For new students)<br/><p className={`${styles.tablepara}`}> ₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/anna-nagar/After-Results-Paper-1-Week-End.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr>
                            <td className={`${styles.tablepara}`}>Chennai - Adyar<br/></td>
                            <td className={`${styles.tablepara}`}>Weekend<br/><p className={`${styles.tablepara}`}>(Offline)</p></td>
                            <td className={`${styles.tablepara}`}>₹5500 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/adyar/After-Results-Paper-1-Regular.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                       
                        <tr>
                            <td className={`${styles.tablepara}`}>Trichy<br/></td>
                            <td className={`${styles.tablepara}`}>Weekend<br/><p className={`${styles.tablepara}`}>(Offline/Online)</p></td>
                            <td className={`${styles.tablepara}`}>₹5500 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/trichy/Group-II-Mains-Paper-1-TB2-Schedule-trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        
                        <tr>
                            <td className={`${styles.tablepara}`}>Madurai<br/></td>
                            <td className={`${styles.tablepara}`}>Weekend<br/><p className={`${styles.tablepara}`}>(Offline)</p></td>
                            <td className={`${styles.tablepara}`}>₹5500 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/madurai/After-Results-Paper-1-Regular-madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr>
                            <td className={`${styles.tablepara}`}>Salem<br/></td>
                            <td className={`${styles.tablepara}`}>Weekend<br/><p className={`${styles.tablepara}`}>(Offline/Online)</p></td>
                            <td className={`${styles.tablepara}`}>₹5500 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/salem/After-Results-Paper-1-Regular-salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr>
                            <td className={`${styles.tablepara}`}>Coimbatore<br/></td>
                            <td className={`${styles.tablepara}`}>Weekend<br/><p className={`${styles.tablepara}`}>(Offline/Online)</p></td>
                            <td className={`${styles.tablepara}`}>₹5500 (For new students)<br/><p className={`${styles.tablepara}`}>₹5000 (For Old students)</p></td>
                            <td><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/coimbatore/after-result-paper-I-sch.1.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr>
                            <td className={`${styles.tablepara}`}>Thiruvarur<br/></td>
                            <td className={`${styles.tablepara}`}>Updated Soon<br/><p className={`${styles.tablepara}`}></p></td>
                            <td className={`${styles.tablepara}`}>Updated Soon<br/><p className={`${styles.tablepara}`}></p></td>
                            <td className={`${styles.tablepara}`}>Updated Soon<br/><p className={`${styles.tablepara}`}></p></td>
                            <td className={`${styles.tablepara}`}>Updated Soon<br/><p className={`${styles.tablepara}`}></p></td>
                        </tr>
                        

                        
                       
                    </tbody>
              </table>
        </div>
        </div>
    </div>
</div>   

{/* mobile view table*/}
<div className="container d-lg-none">
                            <div className="pt-2">
                            <hr/>
                                <p className={`${styles.mbtableheading} `}>Chennai - Anna Nagar<br/></p>
                                <p className={`${styles.tablepara}`}>Weekend<br/>(Offline/Online)</p>
                                <p className={`${styles.tablepara}`}>₹5500 (For new students)<br/> ₹5000 (For Old students)</p>
                                <div><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/anna-nagar/After-Results-Paper-1-Week-End.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <br/>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                                <hr/>
                            </div>
                            <div className="pt-2">
                                <p className={`${styles.mbtableheading} `}>Chennai - Adyar<br/></p>
                                <p className={`${styles.tablepara}`}>Weekend<br/>(Offline)</p>
                                <p className={`${styles.tablepara}`}>₹5500 (For new students)<br/> ₹5000 (For Old students)</p>
                                <div><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/adyar/After-Results-Paper-1-Regular.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <br/>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                                <hr/>
                            </div>
                            <div className="pt-2">
                                <p className={`${styles.mbtableheading}`}>Trichy<br/></p>
                                <p className={`${styles.tablepara}`}>Weekend<br/>(Offline/Online)</p>
                                <p className={`${styles.tablepara}`}>₹5500 (For new students)<br/> ₹5000 (For Old students)</p>
                                <div><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/trichy/Group-II-Mains-Paper-1-TB2-Schedule-trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <br/>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                                <hr/>
                            </div>
                            <div className="pt-2">
                                <p className={`${styles.mbtableheading} `}>Madurai<br/></p>
                                <p className={`${styles.tablepara}`}>Weekend<br/>(Offline)</p>
                                <p className={`${styles.tablepara}`}>₹5500 (For new students)<br/> ₹5000 (For Old students)</p>
                                <div><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/madurai/After-Results-Paper-1-Regular-madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <br/>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                                <hr/>
                            </div>
                            <div className="pt-2">
                                <p className={`${styles.mbtableheading} `}>Salem<br/></p>
                                <p className={`${styles.tablepara}`}>Weekend<br/>(Offline/Online)</p>
                                <p className={`${styles.tablepara}`}>₹5500 (For new students)<br/> ₹5000 (For Old students)</p>
                                <div><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/salem/After-Results-Paper-1-Regular-salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <br/>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                                <hr/>
                            </div>
                            <div className="pt-2">
                                <p className={`${styles.mbtableheading} `}>Coimbatore<br/></p>
                                <p className={`${styles.tablepara}`}>Weekend<br/>(Offline/Online)</p>
                                <p className={`${styles.tablepara}`}>₹5500 (For new students)<br/> ₹5000 (For Old students)</p>
                                <div><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/coimbatore/after-result-paper-I-sch.1.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <br/>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                                <hr/>
                            </div>
                            <div className="pt-2">
                                <p className={`${styles.mbtableheading} `}>Thiruvarur<br/></p>
                                <p className={`${styles.tablepara}`}>Updated Soon</p>
                                {/* <p className={`${styles.tablepara}`}>₹5500 (For new students)<br/> ₹5000 (For Old students)</p>
                                <div><Link href="/pdf/TNPSC-Group-A-Mains-2022-New-Test-series/adyar/After-Results-Paper-1-Regular.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <br/>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div> */}
                                <hr/> 
                            </div>
                            
            </div>  
   

    
    <Interest />
    <Footer />

        </>
    )
}
export default Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper1
